<div ng-class="{'container': !ui.fluidView, 'container-fluid': ui.fluidView}">
    <div class="col-sm-4">
        <div x-config-tree-panel="" id="" class="autoscroll height"></div>
    </div>
    <div class="col-sm-8">
        <div x-config-form-panel="" class="autoscroll height"></div>
    </div>
</div>